import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionRoomState } from '../../../../context';
import { NotesBlock, NotesLabel, NotesText, NotesRow } from './styles';

export const VitalManualNotes: FC = () => {
  const { t } = useTranslation(['session-room']);
  const { vitalsData } = useSessionRoomState();
  const [visitReason, generalNotes] = useMemo(() => {
    const notes = vitalsData.manualNotes;
    return [
      notes?.VisitReason?.trim() || '-',
      notes?.GeneralNotes?.trim() || '-',

    ];
  }, [vitalsData.manualNotes]);

  return (
    <NotesBlock>
      <NotesRow>
        <NotesLabel>{t('session-room:SENSORS.VISIT_REASON')}</NotesLabel>
        <NotesText>{visitReason}</NotesText>
      </NotesRow>
      <NotesRow>
        <NotesLabel>{t('session-room:SENSORS.GENERAL_NOTES')}</NotesLabel>
        <NotesText>{generalNotes}</NotesText>
      </NotesRow>
    </NotesBlock>
  );
};
